export default "__VITE_ASSET__0e00c92f__"